import "antd/es/button/style";
import _Button from "antd/es/button";
import "antd/es/form/style";
import _Form from "antd/es/form";
import "antd/es/row/style";
import _Row from "antd/es/row";
import "antd/es/col/style";
import _Col from "antd/es/col";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import Element from '../element';
import { calcNamePath } from '../../utils/form-utils';
import FormContext from '../../form-context';
import { LocaleContext } from '../../locale';
import './style/index.less';

var Login = function Login(_ref) {
  var parentName = _ref.parentName,
      _ref$config = _ref.config,
      _ref$config$elements = _ref$config.elements,
      elements = _ref$config$elements === void 0 ? [] : _ref$config$elements,
      name = _ref$config.name,
      label = _ref$config.label;

  var _useContext = useContext(FormContext),
      submitText = _useContext.submitText,
      submitting = _useContext.submitting,
      showSubmitButton = _useContext.showSubmitButton;

  var _useContext2 = useContext(LocaleContext),
      formatMessage = _useContext2.formatMessage;

  return _jsxs(_Col, {
    span: 24,
    className: 'igloo-login',
    children: [label && _jsx("div", {
      className: 'igloo-login-label',
      children: label
    }), _jsx("div", {
      className: 'igloo-login-content',
      children: _jsx(_Row, {
        gutter: [32, 24],
        children: elements.map(function (child, index) {
          return _jsx(Element, {
            parentName: calcNamePath(parentName, name),
            config: child
          }, index);
        })
      })
    }), showSubmitButton && _jsx(_Form.Item, {
      children: _jsx(_Button, {
        type: "primary",
        htmlType: "submit",
        className: 'igloo-login-button',
        loading: submitting,
        children: submitText || formatMessage({
          id: 'Log in'
        })
      })
    })]
  });
};

export default Login;